import {
  differenceInYears,
  format,
  isBefore,
  isValid,
  parse,
  startOfDay,
} from "date-fns";
import { t } from "i18next";

export const calculateAge = (dateOfBirth: string) => {
  const date = parse(dateOfBirth, "yyyy-MM-dd", new Date());
  const age = differenceInYears(new Date(), date);
  return age;
};

export const parseBackendDate = (dateString: string) => {
  const formattedDate = parse(dateString, "yyyy-MM-dd", new Date());

  if (isValid(formattedDate)) {
    return formattedDate;
  }

  // We've received a date with timezone information, so let's just use the new Date api
  return new Date(dateString);
};

export const formatBackendDate = (
  dateString: string,
  dateFormat: string = t("common.date_format_day_first"),
) => {
  return format(parseBackendDate(dateString), dateFormat);
};

export const formatDateForBackend = (date: Date) => {
  return format(date, "yyyy-MM-dd");
};

export const isBeforeToday = (a: Date) => {
  const today = new Date();
  return isBefore(startOfDay(a), startOfDay(today));
};

export const calculateTime = (score: number) => {
  const minutes = Math.floor(score / 60);
  const seconds = score % 60;
  return `${minutes} min ${seconds < 10 ? `0${seconds} ` : seconds} sec`;
};
